var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinedCircle = function SvgLinedCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.16,8.48l221.36,221.36c.26-.78.52-1.57.76-2.35L122.51,7.72c-.79.25-1.57.51-2.35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.05,3.21l206.75,206.75c.18-.87.34-1.74.5-2.62L142.66,2.71c-.87.16-1.75.33-2.62.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.12,0c-.98.05-1.96.12-2.93.19l187.62,187.62c.07-.97.13-1.95.19-2.93L165.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.57,159.29L190.71.43c-1.13-.1-2.26-.19-3.39-.27l162.52,162.52c-.08-1.13-.17-2.26-.27-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.58,24.23l240.2,240.2c.39-.65.78-1.3,1.16-1.96L87.54,23.07c-.66.38-1.31.77-1.96,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.08,15.57l232.35,232.35c.33-.71.65-1.43.96-2.15L104.23,14.6c-.72.32-1.44.64-2.15.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.07,128.62L221.38,5.93c-1.4-.38-2.8-.75-4.21-1.1l128,128c-.35-1.41-.71-2.82-1.1-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.17,84.56l-59.73-59.73c-2.39-1.44-4.81-2.83-7.28-4.16l71.17,71.17c-1.33-2.46-2.72-4.89-4.16-7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.69,45.67l247.63,247.63c.5-.54.99-1.09,1.48-1.64L58.34,44.2c-.55.49-1.1.98-1.64,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.47,34.29l245.24,245.24c.44-.6.88-1.2,1.31-1.8L72.28,32.97c-.6.44-1.21.87-1.8,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.71,142.66l204.63,204.63c.87-.16,1.75-.33,2.62-.5L3.21,140.05c-.18.87-.34,1.74-.5,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.72,122.51l219.77,219.77c.79-.25,1.57-.51,2.35-.76L8.48,120.16c-.26.78-.52,1.57-.76,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.6,104.23l231.16,231.16c.72-.32,1.44-.64,2.15-.96L15.57,102.08c-.33.71-.65,1.43-.96,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.07,87.54l239.4,239.4c.66-.38,1.31-.77,1.96-1.16L24.23,85.58c-.39.65-.78,1.3-1.16,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.43,190.71l158.86,158.86c1.13.1,2.26.19,3.39.27L.15,187.32c.08,1.13.17,2.26.27,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,165.12l184.88,184.88c.98-.05,1.96-.12,2.93-.19L.19,162.19c-.07.97-.13,1.95-.19,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.97,72.28l244.75,244.75c.6-.44,1.21-.87,1.8-1.32L34.29,70.47c-.44.6-.88,1.2-1.31,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.2,58.34l247.47,247.47c.55-.49,1.1-.98,1.64-1.48L45.67,56.69c-.5.54-.99,1.09-1.48,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.83,265.44l59.73,59.73c2.39,1.44,4.81,2.83,7.28,4.16l-71.17-71.17c1.33,2.46,2.72,4.89,4.16,7.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.93,221.38l122.69,122.69c1.4.38,2.8.75,4.21,1.1L4.84,217.17c.35,1.41.71,2.82,1.1,4.21Z"
  }))));
};
export default SvgLinedCircle;